module.exports = __webpack_public_path__ + "static/img/purple_staking_discount_coupon.9a9141b6.png";